import { Chip, Hidden, makeStyles, useTheme } from '@material-ui/core'
import clsx from 'clsx'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { DateFilters } from '../../../model/enums/dateFilters'
import { styles } from './genericFilters.styles'
import { GenericFilter } from '../../../pages/tanks/components/tanksList/tanksList.config'

export type GenericFiltersProps<T> = {
  filters: GenericFilter[]
  activeFilter: GenericFilter | undefined
  onSelectFilter: (value: any, activeFilter?: GenericFilter) => void
  // customOnlyResponsive?: boolean
}

const GenericFilters = <T extends string | number | object>({
  filters,
  activeFilter,

  onSelectFilter
  // configuration = { disableFuture: false, disablePast: false, maxPeriod: null },
  // customOnlyResponsive = false
}: GenericFiltersProps<T>) => {
  const [t] = useTranslation(['globalerisLibrary', 'translation', 'enums'])
  const currentTheme = useTheme()
  const useStyles = makeStyles(styles(currentTheme))
  const classes = useStyles()

  // const [active, setActive] = React.useState<GenericFilter | undefined>(activeFilter)

  // const filterChange = React.useCallback(
  //   (filter: GenericFilter) => {
  //     setActive(filter)
  //     onSelectFilter(filter.value, filter)
  //   },
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  //   [activeFilter]
  // )

  // useEffect(() => {
  //   setActive(activeFilter)
  // }, [activeFilter])

  return (
    <>
      <div className={classes.filters}>
        <Hidden only={['xs', 'sm']}>
          {filters.map((filter, index) => (
            // Show Custom Filter Chip if customOnlyResponsive is false
            <Chip
              key={`${filter.id}-${index}`}
              size="small"
              variant={filter.enabled ? 'default' : 'outlined'}
              clickable={filter.enabled}
              className={clsx(classes.filter, { [classes.filterDisabled]: !filter.enabled })}
              label={filter.label}
              color={!filter.inactive && activeFilter?.id === filter.id ? 'primary' : 'default'}
              onClick={() => filter.enabled && onSelectFilter(filter.value, filter)}
            />
          ))}
        </Hidden>
      </div>
    </>
  )
}

export default React.memo(GenericFilters)
